const section = document.querySelector(".main-article");
const collapseList = document.querySelector(".main-article__faq--list");
const headerHeight = document.querySelector("sticky-header").offsetHeight;
const mobileLinks = document.querySelector(".main-article__mobile-section-ref");
const mobileButton = mobileLinks.querySelector("button");
const readTimeEl = document.querySelector(".main-article__read-time span");
const scrollHeightMobileLinks = document.querySelector(
  ".main-article__mobile-wrapper"
).scrollHeight;

let allLinks;
let sectionHeading;
let isFixed = false;
let allLinksMobilePosition;

mobileButton?.addEventListener("click", onLinksCollapse);
collapseList?.addEventListener("click", onCollapse);

document.addEventListener("DOMContentLoaded", function () {
  readingTime();
  allLinks = document.querySelectorAll(".main-article__ref-list");
  const linksElements = allLinks[0].querySelectorAll("[data-href]");

  sectionHeading = document.querySelectorAll(".main-article__content h2, .main-article__content h3, .main-article__content h4");

  linksElements.forEach((link, index) => {
    const text = link.dataset.href;
    sectionHeading[index].setAttribute("id", text);
  });

  allLinks.forEach((section) =>
    section.addEventListener("click", smoothScroll)
  );
  if (window.innerWidth <= 1124) {
    allLinksMobilePosition =
      mobileLinks.getBoundingClientRect().top + window.scrollY;
  }
});

window.addEventListener("scroll", function () {
  if (window.innerWidth <= 1124) {
    const position = window.scrollY;
    if (
      !mobileLinks.classList.contains("fixed") &&
      !mobileButton.classList.contains("close")
    ) {
      const bottomPosition =
        mobileLinks.getBoundingClientRect().bottom + window.scrollY;
      if (position >= bottomPosition) {
        onLinksCollapse();
      }
    } else {
      if (position >= allLinksMobilePosition) {
        mobileLinks.style.top = headerHeight + "px";
        mobileLinks.classList.add("fixed");
      } else {
        mobileLinks.classList.remove("fixed");
      }
    }
  }
});

function smoothScroll(event) {
  event.preventDefault();
  const isMobile = window.innerWidth <= 1124;
  const goToSectionHeight = mobileButton.scrollHeight + 40;
  const closestWrapper = event.currentTarget.closest(
    ".main-article__mobile-section-ref"
  );
  /*When the .main-article__mobile-section-ref is not fixed, the top point of the targetElement 
    to which you want to scroll takes into account the height of the .main-article__mobile-section-ref. 
    To scroll to the correct position, you need to calculate the height of the .main-article__mobile-section-ref 
    (including the margins, which are then reset to zero) and subtract it from the scroll position. */

  let extraHeight = 0;
  if (closestWrapper) {
    const isFixed = closestWrapper.classList.contains("fixed");
    if (!isFixed) {
      extraHeight = closestWrapper.scrollHeight + 64;
    }
  }
  const link = event.target.closest("a");
  if (!link) {
    return;
  }
  const targetId = link.getAttribute("href").substring(1);
  const targetElement = document.getElementById(targetId);

  if (targetElement) {
    const targetPosition = targetElement.offsetTop - headerHeight;

    const newPosition = isMobile
      ? targetPosition - goToSectionHeight - extraHeight
      : targetPosition;
    window.scrollTo({
      top: newPosition,
      behavior: "smooth",
    });
    if (isMobile) {
      onLinksCollapse();
    }
  }
}

function onLinksCollapse() {
  const content = mobileLinks.querySelector(".main-article__mobile-wrapper");
  const openMobileContainer = document.querySelector(
    ".main-article__mobile-section-ref"
  );
  const isFixed = openMobileContainer.classList.contains("fixed");
  const viewportHeight = window.innerHeight - 100;
  if (content.style.maxHeight) {
    collapseMobileLinks(content, openMobileContainer, isFixed);
  } else {
    expandMobileLinks(content, openMobileContainer, isFixed, viewportHeight);
  }
}

function collapseMobileLinks(content, openMobileContainer, isFixed) {
  content.style.maxHeight = null;
  mobileButton.classList.add("close");
  mobileLinks.classList.add("main-article__mobile-section-ref--close");

  if (isFixed) {
    setTimeout(() => {
      openMobileContainer.style.height = null;
    }, 50);
  }
}

function expandMobileLinks(
  content,
  openMobileContainer,
  isFixed,
  viewportHeight
) {
  const maxHeight = scrollHeightMobileLinks;

  content.style.maxHeight = maxHeight + "px";

  if (isFixed && viewportHeight <= maxHeight) {
    openMobileContainer.style.height = "70vh";
  }

  mobileButton.classList.remove("close");
  mobileLinks.classList.remove("main-article__mobile-section-ref--close");
}

function onCollapse(event) {
  const item = event.target.closest("li");
  if (!item) {
    return;
  }
  const activeTab = event.currentTarget.querySelector(
    ".main-article__collapse-button:not(.main-article__collapse-button--close)"
  );
  const button = item.querySelector(".main-article__collapse-button");
  if (activeTab && activeTab != button) {
    const activeContent = activeTab.nextElementSibling;
    activeTab.classList.add("main-article__collapse-button--close");
    closeTab(activeContent, activeTab);
  }

  const content = item.querySelector(".main-article__collapse-content");

  button.classList.toggle("main-article__collapse-button--close");
  if (content.style.maxHeight) {
    closeTab(content, button);
  } else {
    content.style.transition = "max-height .35s ease-out";
    content.style.maxHeight = content.scrollHeight + "px";
    button.querySelector("span").innerText = "-";
  }
}
function closeTab(content, button) {
  content.style.maxHeight = null;
  button.querySelector("span").innerText = "+";
}
function readingTime() {
  const textExcerpt = document.querySelector(
    ".main-article__excerpt"
  )?.innerText;
  const textKeyTakeaway = document.querySelector(
    ".main-article__key_takeaway"
  )?.innerHTML;
  const textMainContent = document.querySelector(
    ".main-article__content"
  )?.innerText;

  const text = textExcerpt + textKeyTakeaway + textMainContent;
  const wpm = 225;
  const words = text.trim().split(/\s+/).length;
  const timeInMinutes = Math.ceil(words / wpm);

  const hours = Math.floor(timeInMinutes / 60);
  const minutes = timeInMinutes % 60;
  const seconds = Math.floor((timeInMinutes * 60) % 60);
  const time = [];
  if (hours) {
    time.push(`${hours} h`);
  }
  if (minutes) {
    time.push(`${minutes} min`);
  }

  if (seconds) {
    time.push(`${seconds} secs`);
  }
  readTimeEl.innerHTML = time.join(", ");
}
